import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import FileUpload from "@/components/FileUpload";
import { inputCls, Field } from "./ui";
import { toast } from "sonner";

export default function SettingsManager() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", {
        about_text: s.about_text, intro_text: s.intro_text,
        about_image_path: s.about_image_path, hero_image_path: s.hero_image_path,
        instagram: s.instagram, email: s.email,
      });
      toast.success("Impostazioni salvate");
    } catch { toast.error("Errore"); } finally { setSaving(false); }
  };

  if (!s) return <Loader2 className="w-6 h-6 animate-spin text-[#C6899E]" />;

  return (
    <div data-testid="cms-settings" className="space-y-6 max-w-2xl">
      <h2 className="font-serif text-2xl">Impostazioni</h2>

      <div className="grid sm:grid-cols-2 gap-6">
        <FileUpload label="Foto Home (hero)" value={s.hero_image_path} onChange={(p) => setS({ ...s, hero_image_path: p })} testid="settings-hero-image" />
        <FileUpload label="Foto Su di me" value={s.about_image_path} onChange={(p) => setS({ ...s, about_image_path: p })} testid="settings-about-image" />
      </div>

      <Field label="Introduzione Home (IT)">
        <textarea rows={3} className={inputCls} value={s.intro_text?.it || ""} onChange={(e) => setS({ ...s, intro_text: { ...s.intro_text, it: e.target.value } })} data-testid="settings-intro-it" />
      </Field>

      <Field label="Testo Su di me (IT)">
        <textarea rows={8} className={inputCls} value={s.about_text?.it || ""} onChange={(e) => setS({ ...s, about_text: { ...s.about_text, it: e.target.value } })} data-testid="settings-about-it" />
      </Field>

      <div className="grid sm:grid-cols-2 gap-6">
        <Field label="Instagram (username)"><input className={inputCls} value={s.instagram || ""} onChange={(e) => setS({ ...s, instagram: e.target.value })} /></Field>
        <Field label="Email"><input className={inputCls} value={s.email || ""} onChange={(e) => setS({ ...s, email: e.target.value })} /></Field>
      </div>

      <p className="text-xs text-[#9C8F94]">Traduzioni EN / FR / ES: lascia vuoto per usare il testo italiano. Potrai aggiungerle in seguito.</p>

      <button onClick={save} disabled={saving} data-testid="settings-save"
        className="inline-flex items-center gap-2 bg-[#C6899E] text-[#4A2233] rounded-full px-7 py-3 text-sm uppercase tracking-[0.12em] hover:bg-[#B4718C] disabled:opacity-40">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Salva
      </button>
    </div>
  );
}
